import React, { Component } from "react";
import Status from "./Status"
import RZ3Status from "./RZ3Status"
import DefaultStatus from "./components/DefaultStatus";
import Logs from "./Logs"
import PartList from "./PartList"
import { Icon, message } from "antd";
import styles from "./deviceInfo.module.less"
import http from "@/http"
import CONST from "@/dataSource/CONST"
const { YingshiProduct } = CONST
class DeviceInfo extends Component {
    state = {
        tabKey: 'info',
        refreshKey: 0,
    }

    get is6100() {
        const { deviceInfo } = this.props;
        let productId = deviceInfo ? deviceInfo.productId : ``;
        return "1235480293853413378" === productId || "1244970249834692610" === productId;
    }

    get isRZ3() {
        const { deviceInfo } = this.props;
        let productId = deviceInfo ? deviceInfo.productId : ``;
        return "1267993677844377602" === productId;
    }

    get isOnline() {
        const { deviceInfo } = this.props;
        let deviceState = deviceInfo ? deviceInfo.deviceState : ``;
        return deviceState === `Normal` || deviceState === `Alarm`;
    }
    get isVideo() {
        const { deviceInfo } = this.props;
        let productId = deviceInfo ? deviceInfo.productId : ``;
        return YingshiProduct[productId];
    }


    componentDidMount() {
        const { deviceInfo } = this.props;
        let { tabKey } = this.state;
        if (deviceInfo && deviceInfo.id && deviceInfo.id.length > 0) {
            if (this.isOnline) {
                if (this.is6100) { tabKey = `status`; }
                else if (this.isRZ3) { tabKey = `RZ3status`; }
                else { tabKey = `info`; }
            }
            else {
                tabKey = `info`;
            }
        }
    }

    changeTab = (tabKey) => {

        this.setState({ tabKey })
    }


    getTabClass = (name, disabled) => {
        const { tabKey } = this.state;
        return disabled ? styles.tabDisabled : (tabKey === name ? styles.tabSelect : styles.tab);
    }

    render() {
        const { deviceInfo, onClose } = this.props;
        const { tabKey, refreshKey } = this.state
        if (!(deviceInfo && deviceInfo.id && deviceInfo.id.length > 0)) return ``;
        let parameter = { refreshKey, deviceInfo, isVideo: this.isVideo }
        let menu = [];
        menu.push({
            name: `详情`,
            value: `info`,
            control: (<DefaultStatus {...parameter} />),
        });
        menu.push({
            name: `常用`,
            value: `status`,
            control: (<Status  {...parameter} />),
            hide: !this.is6100,
            disabled: !this.isOnline,
        });
        menu.push({
            name: `常用`,
            value: `RZ3status`,
            control: (<RZ3Status  {...parameter} />),
            hide: !this.isRZ3,
            disabled: !this.isOnline,
        });
        menu.push({
            name: `日志`,
            value: `log`,
            control: (<Logs  {...parameter} />),
        });

        menu.push({
            name: `配件`,
            value: `part`,
            control: (<PartList  {...parameter} />),
        });
        let showmenu = menu.find(f1 => f1.value === tabKey);
        return (
            <div className={styles.deviceInfoMain} >
                <div className={styles.buttonDiv} >
                    <div className={styles.reLoad} onClick={() => this.setState({ refreshKey: refreshKey + 1 })} >
                        <Icon type='reload' />
                    </div>
                    {onClose ? (<div className={styles.close} onClick={_ => onClose()} >
                        <Icon type='close' />
                    </div>) : ``
                    }
                </div>
                <div className={styles.header}>
                    {menu && menu.length > 0 ?
                        menu.map(item => {
                            if (item.hide) return ``;
                            return (
                                <div
                                    className={this.getTabClass(item.value, item.disabled)}
                                    onClick={() => item.disabled ? `` : this.setState({ tabKey: item.value })}
                                >
                                    {item.name}
                                </div>
                            )
                        })
                        : ``}
                </div>
                <div className={styles.body}>
                    {showmenu ?
                        showmenu.control
                        : ``}
                </div>
            </div>
        )
    }
}
export default DeviceInfo